/*
 * フォーム用のmixin
 */
export default {
  data: function () {
    return {
      form: null,
      isDialog: false,
      dialogForm: null
    }
  },
  mounted: function () {
    // 通常はref="form"が処理対象となる
    // 同一コンポート内に複数のform要素があり、refに"form"以外を用いる必要が場合はsetDialogForm()で再設定する
    this.form = this.$refs.form
  },
  methods: {
    /**
     * poratl内のformにrefがある場合の処理。
     */
    setFormInPortalWhenCreated (formName) {
      formName = formName || 'form'

      // refがportalの中にあるので、mountedではアクセスできないため、イベントをつけておく
      // https://portal-vue.linusb.org/guide/caveats.html#provide-inject
      this.$nextTick().then(
        this.$nextTick(() => {
          this.setDialogForm(this.$refs[formName])
        })
      )
    },
    setDialogForm: function (form) {
      this.form = form
      this.isDialog = true
    },
    // initFormValidation: function () {
    //   this.form.addEventListener('submit', this.checkFormValidity, false)
    // },
    /**
     * フォームの値のチェックを行う
     * @return boolean エラーがあるかどうか
     */
    checkFormValidity: function ($elScroll) {
      this.clearMessages()

      // エラー発生時の処理
      if (this.getErrorInputs().length !== 0) {
        // エラーが発生したら画面先頭に移動
        if ($elScroll) {
          $elScroll.scrollTop = 0
        }
        else if (this.isDialog) {
          // ダイアログの場合はダイアログの中先頭へ
          this.form.querySelector('.modal-body').scrollTop = 0
        }
        else {
          this.scrollToTop()
        }

        // イベント処理停止
        return false
      }
      return true
    },
    /**
     * 入力エラーとなっている入力欄名を取得する
     * @return array errorInputs エラーのある項目名(nameの値)
     */
    getErrorInputs: function () {
      let errorInputs = []
      const inputs = this.form.querySelectorAll('input')

      for (const input of inputs) {
        // 必須項目
        if (input.required) {
          let targetElement = input // 赤枠を設定・解除を行う対象の要素

          // file-droppableの場合は、.bcard-file-droppableの枠を上書きする
          if (input.name === '_files_dummy') {
            targetElement = this.form.querySelector('.bcard-file-droppable')
          }

          // 入力必須項目の項目が空の場合は、赤枠で囲む
          // hiddenのrequiredに対してでもチェックを行う
          if (!input.checkValidity() || input.value.length === 0) {
            // エラーメッセージを表示する(幾つエラーがあっても一つ)
            if (errorInputs.length === 0) {
              this.errors.push('未入力項目があります。')
            }
            // 赤枠をつける
            targetElement.classList.add('invalid')

            errorInputs.push(input.name)
          }
          else {
            // BT48886#c131070 赤枠が付いている項目で、正常である場合は赤枠を外す
            // file-droppableの枠も外す
            targetElement.classList.remove('invalid')
          }
        }
        // 必須項目以外の場合
        else if (input.validity.customError) {
          // 赤枠をつける
          input.classList.add('invalid')
          // エラーメッセージを表示する
          this.errors.push(input.validationMessage)

          errorInputs.push(input.name)
        }
        else {
          // BT48886#c131070 赤枠が付いている項目で、正常である場合は赤枠を外す
          input.classList.remove('invalid')
        }
      }

      return errorInputs
    },
    /*
     * パスワード変更欄のエラーの登録・解除をする
     */
    checkNewWord: function () {
      let input = this.form.querySelector('#word_')
      let input_conf = this.form.querySelector('#word_conf')

      if (input.value !== input_conf.value) {
        // 一致していなかったら、エラーメッセージを表示する
        let msg = 'パスワードとパスワード (確認用)が一致しません。'
        // パスワードの有効期限のダイアログの項目名の場合
        if (input_conf.name === 'new_word_conf') {
          msg = '新しいパスワードと新しいパスワード（確認用）が一致しません。'
        }
        input_conf.setCustomValidity(msg)
      }
      else {
        // エラーメッセージをクリアする
        input_conf.setCustomValidity('')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/form.js